
import React, { useState } from 'react';
import API_BASE_URL from '../apiConfig';

const PaypalForm = ({ onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    const token = localStorage.getItem("token");
    if (!token) {
      setMessage("User is not authenticated. Please log in.");
      setLoading(false);
      return;
    }

    try {
      const paymentData = {
        plan: "monthly",
        amount: "15.99",
      };

      const response = await fetch(`${API_BASE_URL}/api/user/subscribe/paypal`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(paymentData),
      });

      const result = await response.json();
      if (result.url) {
        window.location.href = result.url;  // Open the URL in a new tab
        setMessage("Redirecting to payment...");
      } else if (result.success) {
        setMessage("Payment successful!");
        onSuccess(result.renewDate); // Assuming the API returns `renewDate` in the response
      } else {
        setMessage("Payment failed: " + result.message);
      }
    } catch (error) {
      setMessage("An error occurred: " + error.message);
    }

    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <button
        className="btn btn-light theme-btn premiumMention_btn p-3 text-uppercase rounded-pill text-success fw-bold mb-2"
        type="submit"
        disabled={loading}
      >
        {loading ? "Processing..." : "Paypal"}
      </button>
      {message && <p className='text-warning'>{message}</p>}
      <p className="mb-5" style={{ fontSize: "12px" }}>AUTOMATICALLY RENEWED FOR CONFIDENT USE</p>
    </form>
  );
};

export default PaypalForm;
